// file-download.service.ts
import { Injectable } from '@angular/core';

@Injectable()
export class FileDownloadService {

  constructor() { }

  downloadFile(data: Blob, filename: string) {
    // Create a new URL for the file
    const url = window.URL.createObjectURL(data);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    // Append the link to the body
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/file-download.service.ts